import React from 'react';
import { LogoPlaceholder } from './Placeholders';
export function Hero() {
  return <section className="relative bg-negro w-full min-h-screen flex flex-col overflow-hidden" data-id="element-21">
      {/* Background image */}
      <div className="absolute inset-0 z-0" data-id="element-22">
        <img src="https://cdn.magicpatterns.com/uploads/w4UngRu2B6CFqM9pLKGzti/Fondo_P1.png" alt="Calle empedrada de Purmamarca con el Cerro de los Siete Colores al fondo" className="w-full h-full object-cover object-right md:object-center" data-id="element-23" />
      </div>

      {/* Gradient overlay — clear on top half, darker towards the bottom */}
      <div className="absolute inset-0 z-10" style={{
      background: 'linear-gradient(to bottom, rgba(13,13,13,0) 0%, rgba(13,13,13,0) 50%, rgba(13,13,13,0.85) 85%, rgba(13,13,13,1) 100%)'
    }} aria-hidden="true" data-id="element-24"></div>

      {/* Floating top nav over the image */}
      <header className="relative z-20 w-full" data-id="element-25">
        <div className="max-w-7xl mx-auto px-6 md:px-12 pt-6 md:pt-8 flex items-center justify-between" data-id="element-26">
          <a href="#" aria-label="Inicio" className="translate-x-4 -translate-y-8 md:-translate-y-12 inline-block" data-id="element-27">
            <LogoPlaceholder className="w-44 h-44 bg-transparent" src="https://cdn.magicpatterns.com/uploads/a1uBNmrLGfkF5MPxY5MTuU/ISOLOGO_NB_SF.png" data-id="element-28" />
          </a>

          <nav className="hidden md:flex items-center gap-4 -translate-y-12" data-id="element-29">
            <a href="#historia" className="text-crema font-labrada font-medium text-lg tracking-wider px-5 py-2 rounded-full bg-negro/30 backdrop-blur-sm border border-crema/15 hover:bg-negro/50 transition-colors" data-id="element-30">
              Historia
            </a>
            <a href="#proceso" className="text-crema font-labrada font-medium text-lg tracking-wider px-5 py-2 rounded-full bg-negro/30 backdrop-blur-sm border border-crema/15 hover:bg-negro/50 transition-colors" data-id="element-31">
              Proceso
            </a>
            <a href="#productos" className="text-crema font-labrada font-medium text-lg tracking-wider px-5 py-2 rounded-full bg-negro/30 backdrop-blur-sm border border-crema/15 hover:bg-negro/50 transition-colors" data-id="element-32">
              Productos
            </a>
            <a href="#visitanos" className="text-crema font-labrada font-medium text-lg tracking-wider px-5 py-2 rounded-full bg-negro/30 backdrop-blur-sm border border-crema/15 hover:bg-negro/50 transition-colors" data-id="element-33">
              Visitanos
            </a>
            <a href="#contacto" className="text-crema font-labrada font-medium text-lg tracking-wider px-5 py-2 rounded-full bg-negro/30 backdrop-blur-sm border border-crema/15 hover:bg-negro/50 transition-colors" data-id="element-34">
              Contacto
            </a>
          </nav>

          <button className="md:hidden text-crema p-2 -translate-y-8" aria-label="Menú" data-id="element-35">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-36">
              <line x1="3" y1="12" x2="21" y2="12" data-id="element-37"></line>
              <line x1="3" y1="6" x2="21" y2="6" data-id="element-38"></line>
              <line x1="3" y1="18" x2="21" y2="18" data-id="element-39"></line>
            </svg>
          </button>
        </div>
      </header>

      {/* Hero content — pushed to bottom over the dark gradient area */}
      <div className="relative z-20 flex-1 flex items-end pb-16 md:pb-24" data-id="element-40">
        <div className="text-left px-6 md:px-12 max-w-7xl mx-auto w-full flex flex-col items-start" data-id="element-41">
          <h1 className="font-labrada font-bold text-4xl md:text-7xl text-crema mb-6 leading-tight inline-block px-6 py-3 bg-negro/30 backdrop-blur-sm border border-crema/15 rounded-2xl -translate-y-[240px] md:-translate-y-10 text-center md:text-left" data-id="element-42">
            Textiles Ancestrales <br className="hidden md:block" data-id="element-43" /> para usar y
            vivir
          </h1>
          <p className="font-labrada text-xl md:text-2xl text-crema/90 mb-10 max-w-2xl" data-id="element-44">
            Artesanía familiar de fibras naturales — Quebrada de Humahuaca,
            Jujuy
          </p>
          <a href="#historia" className="bg-marron text-crema font-labrada px-8 py-4 rounded-full hover:opacity-90 transition-opacity text-lg border border-crema/10" data-id="element-45">
            Conocé nuestra historia
          </a>
        </div>
      </div>
    </section>;
}